import css from 'styled-jsx/css'
//import { useRouter } from 'next/dist/client/router'
import { LoginStep } from './enum'
import {
  Dispatch,
  SetStateAction,
  FormEvent,
  useEffect,
  useContext,
  useState,
  ChangeEvent
} from 'react'
import HowToFindOrderModal from '../shared/HowToFindOrderModal'
import { ValidateControl } from '../shared/Input/ValidateControl'
import { useAuthService } from '../../services/auth/auth.service'
import getConfig from 'next/config'
import Loading from '../../components/shared/Loading'
import { useOrderService } from '../../services/shophelp/order.service'
import { OrderContext } from '@ui/contexts'
import { getLocalObject, setLocalObject } from '@ui/helpers'
import { useRedirect } from '@ui/hooks'
import { displayUSPhoneFormatted } from '@ui/helpers'

type CodeFormProps = {
  nextStep: (step?: any) => void
  prevStep: string
  searchForm: { phone: string; email: string }
  setDisplayStatus: Dispatch<SetStateAction<boolean>>
}
export const OrderNumberForm: React.FC<CodeFormProps> = ({
  nextStep,
  setDisplayStatus,
  searchForm
}) => {
  const redirect = useRedirect()
  const { detailByInfoAuth } = useOrderService(getConfig().publicRuntimeConfig.shophelpBasePathApi)
  const { dispatchOrder } = useContext(OrderContext)
  //const router = useRouter()
  const [inputValue, setInputValue] = useState<string>('')
  const [error, setError] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [countdown, setCountdown] = useState<number>(60)
  const { login } = useAuthService(getConfig().publicRuntimeConfig.shophelpBasePathApi)
  const orderNumberRegex = /^#?[0-9]+-[0-9]+$/
  const AUTH_LOGIN = 'AUTH_LOGIN'
  const IS_AUTHEN_TWO_STEP = 'IS_AUTHEN_TWO_STEP'
  const localAuth = getLocalObject(AUTH_LOGIN)

  useEffect(() => {
    let timer: any
    if (countdown > 0) timer = setTimeout(() => setCountdown(countdown - 1), 1000)

    return () => clearTimeout(timer)
  }, [countdown])

  function toForgotOrder() {
    // router.push({
    //   pathname: 'contact/forgot',
    //   query: { ...router.query, ref: 'login' }
    // })
    redirect(`contact/forgot`, {
      routerOptions: { scroll: false },
      query: { ref: 'widget-order-input' }
    })
  }

  async function switchToVerifyCode() {
    setLoading(true)
    let body: Types.LoginModel
    {
      searchForm.phone != ''
        ? (body = {
            phone: searchForm.phone,
            send_sms: true
          })
        : (body = {
            email: searchForm.email,
            send_sms: false
          })
    }
    await login(body, false).then(() => {
      setError('')
      nextStep(LoginStep.CODE)
    })
  }

  async function onConfirm(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (!orderNumberRegex.test(inputValue)) {
      setError('Invalid Order number format, must be XXXX-XXXX (where X is numeric)')
      setDisplayStatus(true)
      return
    }
    setError('')
    const body: Types.LoginModel =
      searchForm.email != ''
        ? {
            email: searchForm.email,
            order: inputValue
          }
        : {
            phone: searchForm.phone,
            order: inputValue
          }
    setLoading(true)
    let email = body?.email
    const result = await login(body).then((data) => {
      setLoading(false)
      if (data === undefined) {
        setError(`We couldn't find your order number`)
        setDisplayStatus(true)
        return false
      }
      setDisplayStatus(false)
      email = data?.email
      return true
    })
    if (result) {
      body.email = email
      onViewOrder(body)
      //alert('OK')
    }
    //setLoading(false)
  }

  async function fetchOrder(body: Types.LoginModel) {
    try {
      await detailByInfoAuth(body).then((res: Types.OrderShopHelp) =>
        dispatchOrder({ type: 'REPLACE', payload: res })
      )
    } catch (err) {}
  }

  async function onViewOrder(order: Types.LoginModel) {
    setLoading(true)
    await fetchOrder(order)
    setLocalObject(IS_AUTHEN_TWO_STEP, true)
    if (order.phone) {
      redirect(`/order`, { routerOptions: { scroll: false }, query: { ref: 'login-phone-order' } })
    } else {
      redirect(`/order`, { routerOptions: { scroll: false }, query: { ref: 'login-email-order' } })
    }
  }

  function onValueChange(value: string) {
    setInputValue(value.trim().toLowerCase())
  }

  return (
    <>
      <style jsx>{compStyle}</style>
      <style jsx>{horizontalLineStyle}</style>
      {loading && <Loading isFullWidth />}
      <div className="login-form ml-auto mr-auto has-text-centered">
        <h1 id={'ord-num-title'} className="login-form__title mt-8 mb-4">
          Fill your order number
        </h1>
        <p className="login-form__content is-flex is-align-items-center is-justify-content-center">
          To verify you, please enter your order number that related to{' '}
          {searchForm.phone != '' || localAuth?.phone ? 'phone' : 'email'}
        </p>
        <b>
          {searchForm.phone != '' || localAuth?.phone
            ? displayUSPhoneFormatted(searchForm.phone) || displayUSPhoneFormatted(localAuth?.phone)
            : searchForm.email || localAuth?.email}
        </b>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            onConfirm(e)
          }}
        >
          <div className="field mt-8">
            <div className={`control has-icons-left`}>
              <span className="is-left icon">#</span>
              <ValidateControl
                id={`ord_num_login_sh_widget`}
                firstSubmit={true}
                title=""
                className={`input${error ? ' is-danger' : ''}`}
                placeholder="Order number..."
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  onValueChange(e.target.value.trim().toLowerCase())
                }}
                value={inputValue ?? ''}
                error={error}
              ></ValidateControl>
            </div>
          </div>
          <a
            className={`is-link-custom has-text-centered how-to-find-ord-num`}
            onClick={() => setIsOpen(true)}
          >
            <span>How to find your order number?</span>
          </a>
          <div className="field mt-8 mb-8">
            <div className={`control`}>
              <button
                id={`ord_num_cf_btn`}
                type="submit"
                className="button is-primary button--cta is-fullwidth-mobile"
                style={{ width: '100%' }}
              >
                Confirm
              </button>
            </div>
            <h2>
              <span>OR</span>
            </h2>
          </div>
          <a
            className="is-link-custom"
            onClick={() => {
              switchToVerifyCode()
            }}
          >
            Fill verification code instead
          </a>
        </form>
      </div>
      <HowToFindOrderModal open={isOpen} setOpen={setIsOpen} toForgotOrder={toForgotOrder} />
    </>
  )
}

const compStyle = css`
  .enter-code {
    background: var(--white-100);
    box-shadow: 2px 4px 40px rgba(161, 178, 203, 0.25);
    border-radius: var(--round-16);
    padding: 2rem;
    max-width: 450px;

    font-size: 15px;
    line-height: 32px;

    p {
      color: var(--indigo-7);
      &.is-danger {
        color: var(--danger);
      }
    }
  }

  .countdown {
    border: 2px solid var(--indigo-1);
    box-sizing: border-box;
    border-radius: var(--round-4);
    width: 200px;
    height: 48px;

    &.is-resent {
      border: 2px solid var(--secondary-50);
      color: var(--secondary-100);
      cursor: pointer;

      span {
        font-weight: 500;
      }

      &:hover {
        background: var(--indigo-2);
        span {
          font-weight: 700;
        }
      }
    }
  }

  .button {
    width: 200px;
    height: 48px;
  }

  .login-form {
    background: var(--white-100);
    box-shadow: 2px 4px 40px rgba(161, 178, 203, 0.25);
    border-radius: var(--round-4);
    padding: 4rem;
    max-width: 450px;

    font-size: 15px;
    line-height: 32px;

    &__title {
      font-size: 21px;
      font-weight: 600;
    }

    &__content {
      color: var(--indigo-7);
    }

    .icon.is-left {
      color: var(--indigo-7);
      margin-top: 9px;

      &::after {
        content: '';
        position: absolute;
        border: 1px solid var(--indigo-3);
        height: 16px;
        right: 0;
      }
    }
    .control.has-icons-left .input {
      padding-left: 3rem;
    }
    :global(.input) {
      ::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: var(--indigo-6);
        opacity: 0.3;
      }
      ::-moz-placeholder {
        /* Firefox 19+ */
        color: var(--indigo-6);
        opacity: 0.3;
      }
      :-ms-input-placeholder {
        /* IE 10+ */
        color: var(--indigo-6);
        opacity: 0.3;
      }
      :-moz-placeholder {
        /* Firefox 18- */
        color: var(--indigo-6);
        opacity: 0.3;
      }
      &:focus {
        border: 1px solid #43c3ff;
        box-shadow: none;
      }
      &:hover {
        box-shadow: none;
      }
    }
  }

  .btn-submit {
    padding: 8px 24px;
    background: var(--white-100);
    border: 2px solid var(--secondary-50);
    box-sizing: border-box;
    border-radius: var(--round-4);
    color: var(--secondary-100);

    &:hover {
      background: var(--indigo-2);
      font-weight: 700;
    }
  }

  .is-link-custom {
    cursor: pointer;
    color: #2d9cdb;
    font-weight: 400;
  }
`

const horizontalLineStyle = css`
  h2 {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid gray;
    line-height: 0.1em;
    margin: 30px 0 20px;
  }

  h2 span {
    background: #fff;
    padding: 0 20px;
    font-weight: 700;
    color: gray;
  }
`
